// Core
import React from 'react';

function Icon(): JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 14 22"
      fill="none"
      data-testid="thermometer-icon"
    >
      <path
        d="M3 4C3 2.93913 3.42143 1.92172 4.17157 1.17157C4.92172 0.421427 5.93913 0 7 0C8.06087 0 9.07828 0.421427 9.82843 1.17157C10.5786 1.92172 11 2.93913 11 4V9.255C12.223 10.1066 13.1423 11.3262 13.6241 12.7365C14.1059 14.1467 14.125 15.6739 13.6788 17.0958C13.2325 18.5176 12.3441 19.76 11.1429 20.642C9.94163 21.524 8.49026 21.9996 7 21.9996C5.50974 21.9996 4.05837 21.524 2.85714 20.642C1.6559 19.76 0.767498 18.5176 0.32123 17.0958C-0.125038 15.6739 -0.105877 14.1467 0.375923 12.7365C0.857723 11.3262 1.77702 10.1066 3 9.255V4ZM4.144 10.895C3.27017 11.5031 2.61325 12.3742 2.26885 13.3816C1.92446 14.3889 1.91058 15.4799 2.22924 16.4957C2.5479 17.5115 3.18245 18.399 4.04053 19.0291C4.89861 19.6593 5.93541 19.9991 7 19.9991C8.06459 19.9991 9.10139 19.6593 9.95947 19.0291C10.8175 18.399 11.4521 17.5115 11.7708 16.4957C12.0894 15.4799 12.0755 14.3889 11.7311 13.3816C11.3868 12.3742 10.7298 11.5031 9.856 10.895L9 10.298V4C9 3.46957 8.78929 2.96086 8.41421 2.58579C8.03914 2.21071 7.53043 2 7 2C6.46957 2 5.96086 2.21071 5.58579 2.58579C5.21071 2.96086 5 3.46957 5 4V10.298L4.144 10.895ZM3 15H11C11 16.0609 10.5786 17.0783 9.82843 17.8284C9.07828 18.5786 8.06087 19 7 19C5.93913 19 4.92172 18.5786 4.17157 17.8284C3.42143 17.0783 3 16.0609 3 15Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default Icon;
